const helpInfo = {
  registerlogin: [
    {
      type: "title",
      content: "注册与登录"
    },
    {
      type: "img",
      content: "registerlogin.png",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1 在线版本：",
        },
        {
          liname: "飞译CAT支持使用手机验证、邮箱验证、账号密码及微信扫描等多种登录方式进行登录，使用手机验证码登录后，将自动注册成功。"
        }
      ]
    },
  ],
  registerlogin1: [
    {
      type: "title",
      content: "注册与登录"
    },
    {
      type: "header",
      content: "登录"
    },

    {
      type: "img",
      content: "registerlogin_1.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "飞译CAT私有化部署版本支持账号密码、手机验证、邮箱验证及微信扫码等方式进行登录。"
        }
      ]
    },
    {
      type: "header",
      content: "注册"
    },
    {
      type: "img",
      content: "registerlogin_2.jpg",
    },
    {
      type: "img",
      content: "registerlogin_3.jpg",
    },
    {
      type: "img",
      content: "registerlogin_4.jpg",
    },
    {
      type: "img",
      content: "registerlogin_5.jpg",
    },
    {
      type: "img",
      content: "registerlogin_6.jpg",
    },

    {
      type: "contentLi",
      content: [
        {
          liname: "注册流程简单快捷，支持手机号注册，注册流程如下："
        },
        {
          liname: "步骤一：验证手机"
        },
        {
          liname: " 输入正确格式的手机号码，点击发送验证码，输入短信中的验证码后点击验证进行手机验证；"
        },
        {
          liname: "步骤二：设置密码"
        },
        {
          liname: "当手机验证码验证成功后，可设置6-16位数字和字母组合作为密码，输入确认密码后，点击注册即可完成该账号的注册；"
        },
        {
          liname: "步骤三：注册成功"
        },
        {
          liname: "账号注册成功后系统自动跳转至登录页面。 注册完成，点击开始登录。"
        }
      ]
    },
    {
      type: "header",
      content: "忘记密码"
    },
    {
      type: "img",
      content: "registerlogin_7.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "重置密码流程如下："
        },
        {
          liname: "输入注册手机号——输入短信验证码验证手机号——设置新密码——密码设置成功——点击去登录，进入主界面。"
        },
      ]
    }
  ],
  project: [
    {
      type: "title",
      content: "项目管理"
    },
    {
      type: "content",
      content: "项目设置时，不但可选择时间，语言，工作流程等基础设置，还可以根据项目需求挂载记忆库、术语库、机器翻译引擎、预翻译、质量保证、断句规则等高级设置。"
    },
    {
      type: "header",
      content: "创建项目"
    },
    {
      type: "img",
      content: "project_1.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1 项目设置：",
        },
        {
          liname: "新建项目时，支持上传多种格式文件，包括：doc、docx、ppt、pptx、xls、xlsx、txt、pdf、xlf，另可自行设定项目名称、语言方向、领域、工作流程、截止时间等信息，点击下一步进入高级设置。"
        }
      ]
    },
    {
      type: "img",
      content: "project_2.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2 项目管理：",
        },
        {
          liname: "项目管理支持新建项目、查看项目状态和进度，可对项目进行查看、设置、统计、下载、删除、筛选操作，如上图所示。"
        }
      ]
    },
    {
      type: "img",
      content: "project_3.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2.1 项目信息：",
        },
        {
          liname: "进入项目详情，查看对应项目信息，点击编辑可修改项目名称和项目截止时间。操作流程：选中对应项目——点击右上角编辑—— 编辑或修改项目名称，截至日期——备注说明或要求——点击完成，打开文件管理。"
        }
      ]
    },
    {
      type: "img",
      content: "project_4.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2.2 文件管理：",
        },
        {
          liname: "点击文件管理页面可上传新文件、查看各文件的进度状态，可对文件进行查看、更新、导出、删除操作。"
        }
      ]
    },
    {
      type: "img",
      content: "project_5.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2.2.1 文件预览：",
        },
        {
          liname: "文件上传成功后自动解析，解析后的文件支持在线预览功能，用户可快速查看该文件是否上传正确，查阅预翻译效果。"
        }
      ]
    },
    {
      type: "img",
      content: "project_6.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2.2.2 文件拆分：",
        },
        {
          liname: "支持按照份数拆分文件，也可按句段拆分和按字数拆分，选择需要拆分的份数，输入对应的值点击确定即可将文件拆分，同时支持重新拆分和合并功能。操作流程：点击文件后对应拆分标识——选择按句拆分/按段拆分——点击确定，然后进行任务分配。"
        }
      ]
    },
    {
      type: "img",
      content: "project_7.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2.2.3 任务分配：",
        },
        {
          liname: "新建项目时选择了相应的项目流程，任务分配页面就会出现对应类型的任务，任务分配时可选择团队中的成员，成员众多时，可通过搜索进行查询和分配。操作流程：点击文件名称后面对应标识——选择分配成员——选中后点击确认，分配完成。"
        }
      ]
    },
    {
      type: "img",
      content: "project_8.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2.3 项目统计：",
        },
        {
          liname: "在项目详情中，可查看项目统计，包括项目总字数、重复字数，以及文件与记忆库各匹配度的重复数据。"
        }
      ]
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2.3.1 统计设置：",
        }
        , {
          liname: "支持按照原文和译文两种维度进行统计。"
        }
      ]
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2.3.2 统计记录：",
        },
        {
          liname: "每次生成的统计报告将会自动保存，供用户查看和下载。"
        }
      ]
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2.3.3 下载统计报告：",
        },
        {
          liname: "支持对统计报告的下载功能。"
        }
      ]
    },
    {
      type: "img",
      content: "project_9.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2.4 下载：",
        },
        {
          liname: "在项目列表中，可下载原文、翻译译文与原译对照、审校译文与原译对照、修订痕迹、TMX、XLF、QA报告文件。"
        }
      ]
    },
    {
      type: "img",
      content: "project_10.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.3.1 新建记忆库：",
        }, {
          liname: "点击创建记忆库，填写库名称、语言方向、领域、上传语料文件（支持txt、xlsx、tmx、zip），点击确定即可创建新的记忆库。"
        }
      ]
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.3.2 合并：",
        },
        {
          liname: "支持记忆库合并功能，合并必须为相同语言方向、领域的记忆库，可选择删除原有记忆库和不删除原有记忆库两种模式，填写合并后的库名称，点击合并即可合并成功。"
        }
      ]
    },
    {
      type: "img",
      content: "project_11.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.3.3 挂载记忆库："
        },
        {
          liname: "挂载记忆库流程：选择对应项目——点击项目名称后面【挂载】，挂载成功。"
        }
      ]
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.4 管理与挂载术语库："
        },
        {
          liname: "支持对术语库进行管理功能，包括新建术语库、合并术语库、编辑、上传、下载和删除功能。"
        }
      ]
    },
    {
      type: "img",
      content: "project_12.jpg",
    },
    {
      type: "contentLi",
      col: 2,
      content: [
        {
          liname: "1.4.1 新建术语库："
        },
        { liname: "挂载记忆库流程：选择对应项目——点击项目名称后面【挂载】，挂载成功。" },
        {
          liname: "挂载记忆库流程：选择对应项目——点击项目名称后面【挂载】，挂载成功。",
        }
      ]
    },
    {
      type: "img",
      content: "project_13.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.4.2 合并："
        },
        {
          liname: "支持术语库合并功能，合并必须为相同语言方向、领域的记忆库，可选择删除原有术语库和不删除原有术语库两种模式，填写合并后的库名称，点击合并即可合并成功。操作流程：打开术语库—点击【合并术语库】—选中需要合并的术语库—选择合并模式—输入合并后术语名—点击【确定】，完成操作。",
        }
      ]
    },
    {
      type: "img",
      content: "project_14.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.4.3 挂载术语库："
        },
        {
          liname: "挂载术语库流程：选择对应项目——点击项目名称后面【挂载】",
        }
      ]
    },
    {
      type: "img",
      content: "project_15.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.5 机器翻译引擎："
        },
        {
          liname: "支持多个机器翻译引擎接入，并可选择其中一种引擎进行机器预翻译，同时可查看每种引擎支持的语种。操作流程：选择机器翻译引擎——选中对应引擎——点击完成，设置成功。操作流程：打开术语库—点击【合并术语库】—选中需要合并的术语库—选择合并模式—输入合并后术语名—点击【确定】，完成操作。",
        }
      ]
    },
    {
      type: "img",
      content: "project_16.jpg",
    },
    {
      type: "contentLi",
      col: 8,
      content: [
        {
          liname: "1.6 预翻译："
        },
        { liname: "在预翻译界面中可进行如下设置：" },
        { liname: "翻译记忆库：" },
        { liname: "可将已挂载的记忆库进行预翻译，100%匹配原文的译文机器翻译结果将被记忆库替换；" },
        { liname: "机器翻译：" },
        { liname: "可控制是否开启机器翻译预翻译功能；" },
        { liname: "将以下句段状态设置为已确认：" },
        { liname: "可将100%匹配的记忆库替换机器翻译结果后，该句段将自动变为已确认状态。" },
        {
          liname: "勾选中对应项目后点击完成，则完成相关操作。",
        }
      ]
    },
    {
      type: "img",
      content: "project_17.jpg",
    },
    {
      type: "contentLi",
      col: 2,
      content: [
        {
          liname: "1.7 质量保证："
        },
        { liname: "支持常用的30种QA检测项，开启后可在翻译任务过程中进行质检检测；可设置严重级别（轻微错误、一般错误、严重错误）便于项目经理后期进行QA报告统计 支持在线QA功能，审校人员修改翻译句段时，系统会自动弹出语言质量错误类型，审校人员进行选择评估后，系统会以备注形式同步到项目组相关人员的编辑器界面中。" },
        {
          liname: "勾选中对应项目后点击完成，则完成相关操作。",
        }
      ]
    },
    {
      type: "img",
      content: "project_18.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.8 文档设置："
        },
        {
          liname: "支持Word、Excel、PPT、CAD、IDML格式文件的翻译内容选择功能，包括：备注、文档属性、隐藏内容等；支持文件内和跨文件重复句子锁定功能，在同一项目下，单个文件和多个文件出现重复时，该句段将自动锁定。根据需求选择目标文档对应导出格式及设置，点击完成即可。 操作流程：打开术语库—点击【合并术语库】—选中需要合并的术语库—选择合并模式—输入合并后术语名—点击【确定】，完成操作。",
        }
      ]
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.9 断句规则："
        },
        {
          liname: "断句规则支持选用本系统、同类平台（比如deeply、小牛翻译等）及自定义创建断句规则。若未创建则为系统默认断句规则，其中自定义规则支持配置断句规则和上传断句规则两种方式。 操作流程：打开术语库—点击【合并术语库】—选中需要合并的术语库—选择合并模式—输入合并后术语名—点击【确定】，完成操作。",
        }
      ]
    },
    {
      type: "img",
      content: "project_19.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.9.1 选择平台自带断句规则："
        },
        {
          liname: "勾选对应规则名称前选择按钮，点击完成即可。",
        }
      ]
    },
    {
      type: "img",
      content: "project_20.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.9.2 配置断句规则："
        },
        {
          liname: "可自定义句段结尾、缩写、数字缩写，填写对应标点和内容，输入原文段落，点击预览断句效果，即可根据设置的规则实时查看断句效果，预览无误后，点击确认。",
        }
      ]
    },
    {
      type: "img",
      content: "project_21.jpg",
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.9.3 上传断句规则："
        },
        {
          liname: "系统支持下载规则模版，通过线下进行断句规则设置，上传已配置好的断句规则文件，即可添加断句规则。上传成功后点击确认，完成操作。",
        }
      ]
    },
  ],
  mytask: [
    {
      type: "title",
      content: "我的任务"
    },
    {
      type: "img",
      content: "mytask_1.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1 任务统计："
        },
        {
          liname: "我的任务页面中统计任务总数、未开始、进行中、已完成、已逾期、逾期完的任务数量。",
        }
      ]
    },
    {
      type: "img",
      content: "mytask_2.jpg"
    },
    {
      type: "contentLi",
      col: 3,
      content: [
        {
          liname: "1.2 任务管理："
        },
        { liname: "用户可查看任务的进度和状态，可快速进行任务、导出译文、上传离线翻译文件。" },
        { liname: "导出译文：在任务列表中，支持导出译文，可离线进行翻译和审校任务。" },
        {
          liname: "离线译文上传：在任务列表中，支持上传离线翻译或审校任务文件，该译文内容将被自动替换线上的结果。",
        }
      ]
    },
  ],
  teammanagement: [
    {
      type: "title",
      content: "团队管理"
    },
    {
      type: "img",
      content: "teammanagement_1.jpg"
    },
    {
      type: "content",
      content: "团队管理支持添加成员、修改成员信息、删除成员和成员统计功能。"
    },
    {
      type: "img",
      content: "teammanagement_2.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1 添加成员："
        },
        {
          liname: "输入成员注册的邮箱地址、成员在团队的名称，选择团队角色及对应权限，点击确认即可邀请成功，并且系统将以消息的方式通知给被添加人，对方同意后将自动加入到团队。",
        }
      ]
    },
  ],
  teachingmanagement: [
    {
      type: "title",
      content: "教学管理"
    },
    {
      type: "header",
      content: "作业管理"
    },
    {
      type: "img",
      content: "teachingmanagement_1.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.1 新建作业："
        },
        {
          liname: "老师可新建作业，上传作业内容，填写作业名称，选择语言方向、领域、截止时间，对学生进行分配作业，该老师团队下的学生将收到作业任务。",
        }
      ]
    },
    {
      type: "img",
      content: "teachingmanagement_2.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.2 作业管理："
        },
        {
          liname: "老师可查看学生作业完成情况，可对作业进行批注和修改，也可以下载作业完成报告。",
        }
      ]
    },
    {
      type: "img",
      content: "teachingmanagement_3.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.3 作业分配："
        },
        {
          liname: "支持教师快速分发作业，教师分配作业后学生界面消息通知显示作业提醒，方便学生快速查看作业，及时收到作业信息。操作流程：点击作业管理中学生作业——点击【分配】——选中对应学生——确认，则作业分配完成。 ",
        }
      ]
    },
    {
      type: "img",
      content: "teachingmanagement_4.jpg"
    },
    {
      type: "contentLi",
      col: 2,
      content: [
        {
          liname: "1.1.4 查询作业完成情况："
        },
        { liname: "教师可随时查询学生答题进度，完成时间，完成状态及完成质量。" },
        {
          liname: "操作流程：点击作业管理——学生作业——单击题目对应查看按钮，查看整体情况，继续点击学生姓名后对应查看，查看学生翻译质量。",
        }
      ]
    },
    {
      type: "img",
      content: "teachingmanagement_5.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2 测试管理："
        },
        {
          liname: "老师可查看学生测试完成结果，批注和修改，也可下载测试报告。",
        }
      ]
    },
    {
      type: "img",
      content: "teachingmanagement_6.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2.1 新建测试："
        },
        {
          liname: "老师可新建测试，上传测试内容，填写测试名称，选择语言方向、领域、开始时间、截止时间，对学生进行分配，该老师团队下的学生将收到测试任务。操作流程：点击作业管理中【作业测试】——点击【创建测试】——编辑相关信息并上传文件——确认，完成操作。",
        }
      ]
    },
  ],
  translationeditor: [
    {
      type: "title",
      content: "译后编辑"
    },
    {
      type: "img",
      content: "translationeditor_1.jpg"
    },
    {
      type: "content",
      content: "从我的任务列表中可进入编辑器页面，支持撤销、重做、查找/替换，句段拆分、向下合并、原文复制到译文、编辑原文、重新机翻、字体设置、自动标记填充、添加术语、模式切换等功能。 "
    },
    {
      type: "img",
      content: "translationeditor_2.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.1 撤销："
        },
        {
          liname: "点击撤销即可撤回刚刚进行的操作。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_3.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.2 重做："
        },
        {
          liname: "点击重做即可恢复刚刚撤销的操作。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_4.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.3 查找/替换："
        },
        {
          liname: "点击查找/替换，在翻译建议栏输入需要查找的内容，系统将自动查找该内容，并统计该结果出现的次数；输入需要替换的内容，可选择单个替换和全部替换。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_5.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.4 句段拆分："
        },
        {
          liname: "将鼠标定位到原文需要拆分的位置，点击拆分图标，即可将原文句段进行拆分。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_6.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.5 向下合并："
        },
        {
          liname: "鼠标左键选择需要合并的句段，点击向下合并图标，即可将该句段与下一句段进行合并。（在语原文中必须为同一段落）",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_7.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.6 将原文复制到译文："
        },
        {
          liname: "选择需操作的句段，点击将原文复制到译文图标，即可将原文复制到译文中。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_8.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.7 编辑原文："
        },
        {
          liname: "点击编辑原文图标即可编辑原文。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_9.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.8 重新机翻："
        },
        {
          liname: "选择需要重新机器翻译的句段，点击重新机翻图标，该句段的译文结果将被更新为最新的机器翻译结果。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_10.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.9 字体设置："
        },
        {
          liname: "点击字体缩放图标，选择字体大小，即可调整原文和译文的字体展示。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_11.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.10 自动标记填充："
        },
        {
          liname: "当原文中出现图片、链接、特殊符号时，系统将进行标记，点击自动填充标记图标，原文中的标记将自动填充到译文对应位置，可进行手动调整。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_12.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.11 添加术语："
        },
        {
          liname: "点击添加术语图标，在翻译建议栏输入术语和术语对应的译文，点击添加，可将该术语添加至术语库或将该术语结果替换到译文，文中出现的术语将高亮显示。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_13.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.1.12 模式切换："
        },
        {
          liname: "译文栏支持标准模式和修订模式，可通过点击模式图标进行切换，修订模式可展示用户对译文的修改痕迹。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_14.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.2 QA记录："
        },
        {
          liname: "当句段中出现QA问题，将会在此处出现QA检测记录，并提示QA问题、严重级别，可进行忽略和恢复。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_15.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.3 修改记录："
        },
        {
          liname: "支持用户修改记录自动保存功能，记录修改的内容、修改时间及修改人等信息。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_16.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.4 原文预览："
        },
        {
          liname: "支持原文预览功能，此处为文件全部内容，译员、审校可根据原文上下文内容对译文进行翻译和修改。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_17.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.5 译文预览："
        },
        {
          liname: "支持译文预览功能，系统可根据原文原格式展示译文。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_18.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.6 翻译建议："
        },
        {
          liname: "如项目挂载了记忆库和术语库，翻译建议栏将进行记忆库和术语提示，为用户提供翻译建议和参考。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_19.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.7 备注："
        },
        {
          liname: "支持对译文进行备注功能，可多人进行备注和编辑备注，调高协同效率。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_20.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.8 词典："
        },
        {
          liname: "支持词典功能，输入需要查的单词，点击翻译即可查看词典结果。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_21.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.9.1 提交任务："
        },
        {
          liname: "当任务完成后，译员或审校可以提交任务至下一工作流程。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_22.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.9.2 搜索引擎设置："
        },
        {
          liname: "支持编辑器内容在搜索引擎中查找功能，点击设置可选择百度、bing、搜狗、google等引擎进行搜索。",
        }
      ]
    },
    {
      type: "img",
      size: "min",
      content: "translationeditor_23.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.9.3 导出："
        },
        {
          liname: "编辑器中可导出原文、译文和双语对照文件。",
        }
      ]
    },
    {
      type: "img",
      size: "min",
      content: "translationeditor_24.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.9.4 快捷键："
        },
        {
          liname: "编辑器支持快捷键操作，点击快捷键可查看系统支持的快捷操作键位。",
        }
      ]
    },
    {
      type: "img",
      content: "translationeditor_25.jpg"
    },
    {
      type: "contentLi",
      content: [
        {
          liname: "1.9.5 视图模式："
        },
        {
          liname: "编辑器支持个性化视图模式，包括：普通模式、夜间模式、护眼模式。",
        }
      ]
    },
  ]
}
export default helpInfo